const IdentityAuth = {
  // // 获取分页认证列表
  // list: `/authApi/user/v1/auth/list`,
  // 获取认证说明描述信息 -- 阿松
  desc: `/authApi/user/v1/auth/desc`,
  // 获取认证信息 -- 阿松
  auth: `/authApi/user/v1/auth`,
  // 提交用户认证申请 -- 阿松
  apply: `/authApi/user/v1/auth/apply`,
  // 用户认证申请信息 -- 阿松
  applyInfo: `/authApi/user/v1/auth/apply_info`,
  // 获取用户当前认证信息 -- 阿松
  info: `/authApi/user/v1/auth/info`,
  // 用户认证状态 -- 阿松
  status: `/authApi/user/v1/auth/status`
};

export default IdentityAuth;
